module.exports = __webpack_public_path__ + "static/media/new-york-72.1264871a.jpg";